import { TranslationMap } from '@trimble-gcs/i18n-types';

export function configTranslations() {
  return {
    breadcrumbs: {
      settings: {
        text: $localize`:@@config.breadcrumbs.settings:Settings`,
        desc: 'Title of the settings page',
      },
    },
    tabs: {
      storage: {
        text: $localize`:@@config.tabs.storage:Cloud Storage`,
        desc: 'Text of the storage tab on the settings page.',
      },
      recycleBin: {
        text: $localize`:@@config.tabs.recycleBin:Recycle Bin`,
        desc: 'Text of the recycle bin tab on the settings page.',
      },
      classifications: {
        text: $localize`:@@config.tabs.classifications:Classification Template`,
        desc: 'Text of the classifications tab on the settings page.',
      },
      permissions: {
        text: $localize`:@@config.tabs.permissions:Permissions`,
        desc: 'Text of the permissions tab on the settings page.',
      },
    },
    discardChanges: {
      title: {
        text: $localize`:@@config.discardChanges.title:Discard Changes`,
        desc: 'Title of the dialog that asks the user if they want to discard their unsaved changes.',
      },
      message: {
        text: $localize`:@@config.discardChanges.message:Do you want to discard your unsaved changes?`,
        desc: 'Message of the dialog that asks the user if they want to discard their unsaved changes.',
      },

      confirm: {
        text: $localize`:@@config.discardChanges.confirm:Discard`,
        desc: 'Text of the button that confirms the user wants to discard their unsaved changes.',
      },
    },
  } satisfies TranslationMap;
}
